import { Injectable } from '@angular/core';
import {   HttpGeneralService} from '../../../shared';
import { CONFIG } from '../../../shared/config';
import {City} from './city';
let citiesUrl = CONFIG.baseUrls.cities;

@Injectable()
export class CityService {
    constructor(private httpGeneralService: HttpGeneralService ) {
    }

    searchCities(k?: string, paramObj?: any) {
        let govCode = 0;
        if (Object.keys(paramObj).length > 0)
            govCode = paramObj['govCode'];
        let keyword = k || " ";
        return this.httpGeneralService.getWith(`${citiesUrl}/search/${govCode}/${keyword}`);
    }

    getCities(serial:number=0) { 

        return this.httpGeneralService.getWith(`${citiesUrl}`)
  
       
    }

    addCity(city: City) {
        return this.httpGeneralService.add<City>(city, citiesUrl)
    }

    getCity(id: number) {
        return this.httpGeneralService.get(id, citiesUrl)
    }

    updateCity(city: City) {
        return this.httpGeneralService.update<City>(city.code, city, citiesUrl)
    }

    deleteCity(city: City) {

        return this.httpGeneralService.delete<number>(city.code, `${citiesUrl}`)

        
    }


}

